import React from 'react';
import { Stack, Skeleton, IconButton, Divider, Typography } from '@mui/material';
import DeviceManager from '@/components/util/deviceManager';
import {
  CrossIcon,
  ChevronLeftIcon,
  RedCircleIcon,
  DotsIcon,
  LocationIcon,
} from '@/components/navigation/NavigationIntroScreen/components/Popup/Icons';
import {
  Background,
  choicePopupPointBtn,
  Wrapper,
} from '@/components/navigation/NavigationIntroScreen/components/Popup/styles';

interface NavigationFallbackSkeletonProps {
  rtl?: boolean;
  translation?: any;
  setVisible: (val: boolean) => void;
}

export const NavigationFallbackSkeleton: React.FC<NavigationFallbackSkeletonProps> = ({
  rtl = false,
  translation,
  setVisible,
}) => {
  const isMobile = DeviceManager.isMobile();

  return (
    <>
      <Background
        id="tour-share-popup"
        open
        isVisible
        style={{
          background: 'none',
          backdropFilter: 'blur(0px)',
          position: isMobile ? 'relative' : 'fixed',
          marginTop: isMobile ? 'unset' : '84px',
          height: isMobile ? '100%' : 'auto',
          display: open ? '' : 'none',
          width: isMobile ? '100%' : 'fit-content',
        }}
      >
        <Wrapper
          open
          onClick={(e) => e.stopPropagation()}
          style={{
            position: isMobile ? 'relative' : 'static',
            padding: '0px',
            width: isMobile ? 'auto' : '340px',
            height: isMobile ? '100%' : 'auto',
            border: isMobile ? 'none' : '1px solid #F7F7F7',
            transform: 'none',
            animation: 'none',
            marginLeft: isMobile ? '0' : '20px',
            background: isMobile ? 'none' : '#F7F7F7',
            borderRadius: '14px',
          }}
        >
          <Stack
            direction="row"
            sx={{
              p: { xs: '0 14px 10px 14px', sm: '14px' },
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <IconButton
              sx={{
                visibility: { xs: 'hidden', sm: 'visible' },
                borderRadius: '1rem',
                padding: '4px',
                background: '#EAECF0',
                width: '32px',
                height: '32px',
              }}
              disabled
            >
              <ChevronLeftIcon style={{}} />
            </IconButton>
            {translation?.navDirections ? (
              <Typography sx={{ direction: rtl ? 'rtl' : 'ltr', color: '#000000' }}>
                {translation.navDirections}
              </Typography>
            ) : (
              <Skeleton variant="text" width={80} height={24} />
            )}
            <IconButton
              style={{
                borderRadius: '1rem',
                padding: '4px',
                background: '#EAECF0',
                width: '32px',
                height: '32px',
              }}
              onClick={() => {
                console.log('click to cross')
                setVisible(false)}}
            >
              <CrossIcon style={{ width: '18px', height: '18px' }} />
            </IconButton>
          </Stack>
          <Divider style={{ margin: '0px -24px' }} />
          <Stack className={'show'}>
            <Stack padding="14px 14px 20px 14px">
              <Stack direction="row" justifyContent="space-around">
                <Stack width="100%" mr="6px">
                  <IconButton
                    disabled
                    sx={{ ...choicePopupPointBtn, direction: rtl ? 'rtl' : 'ltr' }}
                  >
                    <Skeleton
                      variant="rectangular"
                      width={30}
                      height={30}
                      sx={{ borderRadius: '4px' }}
                    />
                    <Skeleton variant="text" width="60%" height={20} />
                  </IconButton>
                  <IconButton
                    style={{
                      marginTop: '10px',
                      direction: rtl ? 'rtl' : 'ltr',
                      ...choicePopupPointBtn,
                    }}
                    disabled
                  >
                    <Skeleton
                      variant="rectangular"
                      width={30}
                      height={30}
                      sx={{ borderRadius: '4px' }}
                    />
                    <Skeleton variant="text" width="60%" height={20} />
                  </IconButton>
                </Stack>
                <Stack alignItems="center" gap="8px" height="110px" justifyContent="center">
                  <RedCircleIcon style={{ width: '14px', height: '14px' }} />
                  <DotsIcon style={{ width: '18px', height: '35px' }} />
                  <LocationIcon style={{ width: '14px', height: '18px' }} />
                </Stack>
              </Stack>
            </Stack>
          </Stack>
          {Array.from({ length: 4 }).map((_, i) => (
            <Stack
              key={i}
              direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{
                mb: '10px',
                borderRadius: '8px',
                border: '1px solid #EAECF0',
                background: '#FFF',
                p: '14px',
                width: '90%',
                gap: '10px',
                mx: 'auto',
              }}
            >
              <Skeleton variant="rectangular" height={24} width={311} />
            </Stack>
          ))}
        </Wrapper>
      </Background>
    </>
  );
};
